export const filterObjectBooleans = (obj: Record<string, boolean | null>) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v === true || v === false))
}
